import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type UpdateAssetApiResponse } from '../services/updateAssetService'

export interface UpdateAssetState {
  isLoading: boolean
  error: string | undefined
  data: UpdateAssetApiResponse | undefined
  httpStatus: number | undefined
}

export const initialState: UpdateAssetState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const updateAssetSlice = createSlice({
  name: 'UpdateAssetSlice',
  initialState,
  reducers: {
    updateAssetLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    updateAssetUpdateAction: (state, action: PayloadAction<{ data: UpdateAssetApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    updateAssetErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    reset: () => initialState
  }
})

export const {
  updateAssetLoadingAction,
  updateAssetUpdateAction,
  updateAssetErrorAction,
  reset
} = updateAssetSlice.actions

export default updateAssetSlice.reducer
